var map = {
	"./Knit-pattern_blue.png": 880,
	"./Knit-pattern_dark.png": 112,
	"./Knit-pattern_green.png": 660,
	"./Knit-pattern_photo.png": 477,
	"./Knit-pattern_purple.png": 77,
	"./Knit-pattern_red.png": 102,
	"./Knit-pattern_teal.png": 592,
	"./Knit-pattern_white.png": 294,
	"./Knit-pattern_yellow.png": 750
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 532;